<template>
  <div v-if="cur_group.name !== undefined" class="device-group__config">

    <div class="device-group__config-info">
      <div class="header" v-if="!hidden_items">
        <fg-input
          v-model="cur_group.name"
          class="name"
          type="text"
          placeholder="name group"
          :label="translate('group.name')"
          @keydown.enter="save_group"
        />
        <button
          class="mdi mdi-content-save btn btn-success"
          @click.prevent="save_group"
          :disabled="check_change"
        >
          <b>{{translate('config.save')}}</b>
        </button>

        <router-link
          class="mdi mdi-eye btn btn-success"
          :to="open_device_group(group.id)"
        >
          <b>{{translate('config.show_group_devices')}}</b>
        </router-link>
      </div>

      <div class="main_block" v-if="!hidden_items">
        <sis-select
          v-model="cur_group.client_id"
          :options="client_list"
          :label="translate('device.config.client')"
          :placeholder="translate('device.config.client')"
          :readonly="!this.$store.getters.getPermissions.permissionGod"
          :clearable="false"
        />
        <fg-input
          v-model="cur_group.user_name"
          class="name"
          type="text"
          :label="translate('device.config.user')"
          :placeholder="translate('device.config.user')"
          :readonly="true"
        />
        <fg-input
          v-model="created"
          class="name"
          type="text"
          :label="translate('device.config.created')"
          :placeholder="translate('device.config.created')"
          :readonly="true"
        />
        <fg-input
          v-model="updated"
          class="name"
          type="text"
          :label="translate('device.config.updated')"
          :placeholder="translate('device.config.updated')"
          :readonly="true"
        />
      </div>
      <div class="main_block" v-if="$store.getters.getPermissions.editDeviceGroupConfig === true">
        <button class="btn btn-success btn-fill" @click.prevent="open_modal_config()">
          {{ translate('device.config.open_group_config') }}
        </button>
      </div>
    </div>

    <div v-if="cnt_mul !== 0" class="device-group__config-multi_instance">
      <div
        v-for="(value, key) in config.multi_instance"
        :key="key"
        class="device-group__config-multi_instance-item"
      >
        <span>
          Multi Link {{ key }}:
          <span class="mdi mdi-delete" @click="delete_multi(key)"/>
        </span>
        <textarea v-model="config.multi_instance[value]"/>
      </div>
    </div>
  </div>
</template>

<script>
import ModalConfig from './ModalConfig'
// import VueSplitter from '@rmp135/vue-splitter'

export default {
  name: 'DeviceGroupConfig',
  props: ['group', 'clients'],
  components: {
    // VueSplitter
  },
  data () {
    return {
      config_data: {
        config : {
          multi_instance: {},
        }
      },
      hidden_top: true,
      hidden_bottom: true,
      cur_group: {}
    }
  },
  computed: {
    cnt_mul () {
      return Object.keys(this.config_data.config.multi_instance).length
    },
    created(){
      return this.get_date(this.group.ts_create)
    },
    updated(){
      return this.get_date(this.group.ts_update)
    },
    mobile_version(){
      return document.body.clientWidth < 768
    },
    client_list(){
      let list = []
      for (let client of this.clients) {
        list.push({id: client.id, label: client.name })
      }
      return list
    },
    check_change(){
      return !(((this.group.client_id !== this.cur_group.client_id) && (this.cur_group.client_id !== '')) || this.group.name !== this.cur_group.name)
    },
    hidden_items(){
      return this.cur_group.id === 0
    }
  },
  watch: {
    group () {
      if (Object.keys(this.group).length > 0 ) {
        this.cur_group = {...this.group}

        if (this.$store.getters.getPermissions.editDeviceGroupConfig === true){
          this.$http.v1.getDeviceGroupConfig(this.group.id, (response) => {
            this.config_data = response.data
            if (Array.isArray(this.config_data.config.multi_instance)) {
              this.config_data.config.multi_instance = {}
            }
          })
        }


      }else{
        this.cur_group = {}
      }
    }
  },
  methods: {
    open_modal_config(){
      var t = this.$createElement(ModalConfig,{
        props: {
          group: this.group,
          config: this.config_data
        },
        on: {
          close: () => {
            this.$modal.hide('dynamic-modal')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        adaptive: true,
        clickToClose: true,
        scrollable: true,
        name: 'dynamic-modal'
      })
    },
    add_multi () {
      this.config_data.config.multi_instance['multi_link_' + (this.cnt_mul + 1)] = ''
      this.config_data.config = {...this.config_data.config}
    },
    save_config () {
      this.$http.v1.saveDeviceGroupConfig({...this.cur_group, config: this.config},() => {
        this.global_notify('info', this.translate('config.saved_success'))
        this.$store.dispatch('deviceGroupUpdate')
      })
    },
    save_group () {
      this.$http.v1.updateGroup({...this.cur_group},() => {
        this.global_notify('info', this.translate('group.updated'))
        this.$store.dispatch('deviceGroupUpdate')
      })
    },
    open_device_group(id){
      return {path: '/device_group/' + id}
    },

    delete_multi (key) {
      if (confirm('Действительно удалить Multi Link ' + key + '?')) {
        delete this.config_data.config.multi_instance[key]
        let cnt = 0
        let multi = {}
        for (let i in this.config_data.config.multi_instance) {
          multi['multi_link_' + (++cnt)] = this.config_data.config.multi_instance[i]
        }
        this.config_data.config.multi_instance = multi

        this.config_data = {...this.config_data}
      }
    }
  }
}
</script>

<style lang='scss' scoped>
  .device-group{
    &__config{
      display: flex;
      flex-direction: column;
      overflow: hidden;
      height: 100%;
      padding: 10px;
      &-info{
        margin-bottom: 10px;
        .header{
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          flex-wrap: wrap;
          .name{
            width: 50%;
            margin-bottom: 0;
          }
          .btn{
            padding: 7px;
            height: 40px;
            width: 24%;
          }
        }
        .main_block{
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          flex-wrap: wrap;
          opacity: 1;
          transition: 0.3s;
          padding: 5px 0;
          &.-hide{
            height: 0;
            opacity: 0;
          }
          .form-group{
            width: 50%;
            padding: 2px;
            margin-bottom: 10px;
          }
          .btn{
            width: 100%;
          }
        }
      }
      &-multi_instance{
        flex: 10;
        width: 100%;
        height: 100%;
        overflow: auto;
        &-item{
          flex: 2;
          display: flex;
          flex-direction: column;
          padding: 0 5px;
          textarea{
            width: 100%;
            overflow: auto;
            min-height: 200px;
            flex:2;
          }
        }
      }
    }
  }

  @media (max-width:1560px) {
    .device-group{
      &__config{
        &-info{
          .header{
            .name{
              width: 100%;
              margin-bottom: 10px;
            }
            .btn{
              width: 49%;
            }
          }
        }
      }
    }
  }

  @media (max-width:768px) {
    .device-group{
      &__config{
        padding: 10px 0;
        overflow: auto;
        &-info{
          .header{
            .name{
              width: 70%;
              margin-bottom: 0;
            }
            .btn{
              width: 13%;
              padding: 7px;
              b{
                display: none;
              }
            }
          }
        }
        &-multi_instance{
          overflow: visible;
        }
      }
    }
  }
</style>
